export default "__VITE_ASSET__NNjx08FS__"